import { __assign } from 'tslib';

var editor = {
    base: {
        border: "1px solid",
        borderColor: "black.20",
        borderRadius: 3,
        font: "body",
    },
    variants: {
        disabled: { true: { cursor: "not-allowed" } },
    },
    variantOrder: ["disabled"],
};
var contentStyles = {
    font: "body",
    h1: { margin: 0, marginBottom: "1rem" },
    h2: { margin: 0, marginBottom: "1rem" },
    h3: { margin: 0, marginBottom: "1rem" },
    h4: { margin: 0, marginBottom: "1rem" },
    h5: { margin: 0, marginBottom: "1rem" },
    h6: { margin: 0, marginBottom: "1rem" },
    p: { margin: 0, marginBottom: "1rem", minHeight: "1.5rem" },
    "li p": { margin: 0 },
};
var editorContent = {
    base: __assign({ ".ProseMirror": {
            p: 5,
            minHeight: "var(--editor-min-height)",
            maxHeight: "var(--editor-max-height)",
            overflow: "auto",
        }, ".ProseMirror p.is-editor-empty:first-of-type:before": {
            color: "black.40",
            content: "attr(data-placeholder)",
            float: "left",
            height: 0,
            pointerEvents: "none",
        }, ".ProseMirror.ProseMirror-focused": {
            outline: "none",
            boxShadow: 0,
        } }, contentStyles),
    variants: {
        disabled: { true: { opacity: 0.6, cursor: "not-allowed" } },
    },
    variantOrder: ["disabled"],
};
var editorMenuButton = {
    base: {
        color: "black",
        "&[data-is-active=true]": { bg: "primary.100", color: "white" },
    },
};
var editorSelectionMenu = {
    base: {
        display: "inline-grid",
        border: "1px solid",
        borderColor: "black.20",
        bg: "white",
        borderRadius: 3,
        gap: 2,
        gridAutoFlow: "column",
        boxShadow: 2,
        p: 2,
    },
};
var editorToolbar = {
    base: {
        display: "grid",
        p: 3,
        gap: 2,
        gridAutoFlow: "column",
        justifyContent: "start",
        borderBottom: "1px solid",
        borderColor: "black.20",
    },
};
var richTextView = {
    base: contentStyles,
};

export { editor, editorContent, editorMenuButton, editorSelectionMenu, editorToolbar, richTextView };
//# sourceMappingURL=editor.js.map
